import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import { SPECIALTY_IDS, getSpecialty } from 'config/specialtyConfig';
import { hasPaidAccess, ADDON_DISCOUNT_PERCENT } from 'config/subscriptionPlans';

const AddonCrossSellBanner = ({ userDetails, activeSpecialty }) => {
    const history = useHistory();

    if (!userDetails) return null;
    if (!hasPaidAccess(userDetails, activeSpecialty)) return null;

    const addonTargets = SPECIALTY_IDS.filter(
        id => id !== activeSpecialty && !hasPaidAccess(userDetails, id)
    );
    if (addonTargets.length === 0) return null;

    const targetNames = addonTargets.map(id => getSpecialty(id).name);
    const targetLabel = targetNames.length === 1
        ? targetNames[0]
        : targetNames.slice(0, -1).join(', ') + ' & ' + targetNames[targetNames.length - 1];

    return (
        <Row className="mb-3">
            <Col xs="12">
                <div
                    className="shadow"
                    style={{
                        background: 'linear-gradient(135deg, #f5365c 0%, #f56036 100%)',
                        borderRadius: '10px',
                        padding: '14px 20px',
                        cursor: 'pointer',
                    }}
                    onClick={() => history.push('/client/plans')}
                >
                    <div className="d-flex align-items-center justify-content-between flex-column flex-md-row">
                        <div className="d-flex align-items-center mb-2 mb-md-0">
                            <div className="d-flex align-items-center justify-content-center mr-3" style={{
                                width: '40px', height: '40px', borderRadius: '50%',
                                backgroundColor: 'rgba(255,255,255,0.25)',
                                flexShrink: 0,
                            }}>
                                <i className="fas fa-plus-circle" style={{ color: '#fff', fontSize: '1.1rem' }}></i>
                            </div>
                            <div>
                                <strong style={{ color: '#fff', fontSize: '0.95rem' }}>
                                    <i className="fas fa-fire mr-1" style={{ color: '#ffd600' }}></i>
                                    Add {targetLabel} — save {ADDON_DISCOUNT_PERCENT}%
                                </strong>
                                <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.78rem' }}>
                                    Discounted add-on pricing available for your account
                                </div>
                            </div>
                        </div>
                        <button
                            className="btn btn-white btn-sm mb-0 font-weight-bold"
                            style={{ color: '#f5365c' }}
                            onClick={(e) => { e.stopPropagation(); history.push('/client/plans'); }}
                        >
                            <i className="fas fa-plus-circle mr-1" />
                            Add Now
                        </button>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

const mapStateToProps = state => ({
    userDetails: state.loginAuth.userDetails,
    activeSpecialty: state.specialty.activeSpecialty,
});

export default connect(mapStateToProps)(AddonCrossSellBanner);
